// extracted by mini-css-extract-plugin
export default {"number":"Steps__number-y9ZM","steps":"Steps__steps-Bw7k","step":"Steps__step-S90p"};